import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

let bugSnagReleaseStage = 'production';
let bugSnagReleaseVersion = 'unknown'
let bugSnagKey = null;
if (typeof process.env.NODE_ENV !== 'undefined' ) {
  bugSnagReleaseStage = process.env.NODE_ENV;
}
if (typeof process.env.appVersion !== 'undefined' ) {
  bugSnagReleaseVersion = process.env.appVersion;
}
if (typeof process.env.bugSnagKey !== 'undefined' ) {
  bugSnagKey = process.env.bugSnagKey;
}


const bugsnagClient = bugsnag({
  apiKey: bugSnagKey || '8c1e2771b55c51bb1a84db4a1ff56b6a',
  releaseStage: bugSnagReleaseStage,
  appVersion: bugSnagReleaseVersion
})
bugsnagClient.use(bugsnagVue, Vue)

const install = function (Vue, options = {}) {
  if (install.installed) return false

  Vue.prototype.$bugsnag = bugsnagClient;
}

const bugsnagPlugin = {
  install
}

Vue.use(bugsnagPlugin)
